const X_GATEWAY_SERVED_BY = 'X-Gateway-Servedby';

const MAPPING_REGIONS = {
  'eu-west-1': 'gw51.skyscanner.net',
  'eu-central-1': 'gw53.skyscanner.net',
  'ap-northeast-1': 'gw54.skyscanner.net',
  'ap-southeast-1': 'gw52.skyscanner.net',
};

export { X_GATEWAY_SERVED_BY, MAPPING_REGIONS };
